// @ts-nocheck
//add constant for kanban board
export const VIEWMODE_KANBAN = 'kanban';
//add constant for kanban viewMode (list or board)
export const VIEWMODE_TIMELINE = 'timeline';

export const ERROR_MESSAGES = {
  CREATE_NO_PERMISSION: 'You do not have permission to create this item.',
  DELETE_NO_PERMISSION: 'You do not have permission to delete this item.',
  MOVE_NO_PERMISSION: 'You do not have permission to move this item.',
  RENAME_NO_PERMISSION: 'You do not have permission to rename this item.',
};
